import { Controller } from "@hotwired/stimulus"
import Swiper from "swiper/bundle"
import "swiper/css/bundle"

// プレビュー閲覧用（確認画面）Swiper。template-selector とは別設定。
export default class extends Controller {
  private swiper: Swiper | null = null

  connect() {
    this.initializeSwiper()
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy()
      this.swiper = null
    }
  }

  private initializeSwiper() {
    this.swiper = new Swiper(this.element as HTMLElement, {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 100,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      loop: false,
      // autoHeight: true,
      on: {
        init: () => {
          this.dispatchInitComplete()
        },
      },
    })
  }

  private dispatchInitComplete() {
    const event = new CustomEvent('preview-viewer:init-complete', {
      bubbles: true,
      cancelable: false,
    })
    this.element.dispatchEvent(event)
  }
}


